<template>
  <a-breadcrumb v-if="list?.length > 1" style="margin-bottom: 12px;">
    <!-- <a-breadcrumb-item><router-link to="/">首页</router-link> </a-breadcrumb-item> -->
    <a-breadcrumb-item v-for="item in list" :key="item.title">
      <!-- <router-link v-if="item.link" :to="item.link">{{ item.title }}</router-link> -->
      <span >{{ item.title }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const list = computed(() => {
  return route.matched.map((o, i) => {
    const title = o.meta?.title || ''
    let link
    if (i !== route.matched.length - 1) {
      link = o.path
    }
    return { title, link }
  })
})
</script>
